"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    'zéro',
    'un',
    'deux',
    'trois',
    'quatre',
    'cinq',
    'six',
    'sept',
    'huit',
    'neuf',
    'dix',
];
